import { concat } from '@ember/helper'
import Component from '@glimmer/component'
import { t } from 'ember-intl'

type Fields = Record<string, unknown>

interface Signature<F extends Fields> {
  Args: {
    fields: Partial<F>
    key: Partial<keyof F>
  }
}

export class LessonField<F extends Fields> extends Component<Signature<F>> {
  get value() {
    return this.args.fields[this.args.key]
  }

  get formattedValue() {
    return this.lessonDataValueToString(this.value)
  }

  private lessonDataValueToString(value?: unknown) {
    if (Array.isArray(value)) return value.join(', ')
    if (typeof value === 'string') return value
    if (typeof value === 'number') return String(value)
    return '-'
  }

  <template>
    <dt class="text-dusty-black-200 uppercase">
      {{t (concat "components.tiles.lessonPreviewEntry.lessonData." @key)}}
    </dt>
    <dd class="mb-4">
      {{this.formattedValue}}
    </dd>
  </template>
}

export default LessonField
